import { render, staticRenderFns } from "./JwCangkuList.vue?vue&type=template&id=d77ad1de"
import script from "./JwCangkuList.vue?vue&type=script&lang=js"
export * from "./JwCangkuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports